import { net_common } from "@/api/http";
export const API_DisplayBopAccountManageScreen = (...params) =>
  net_common.post("/api/STDSDC02C07/DisplayBopAccountManageScreen", ...params);

export const API_AddBopAccount = (...params) =>
  net_common.post("/api/STDSDC02C07/AddBopAccount", ...params);

export const API_SendMailToAccountNotification = (...params) =>
net_common.post("/api/STDSDC02C07/SendMailToAccountNotification", ...params);

